var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_html.js
// module id = 72
// module chunks = 0